import InfoComponent from './components/InfoComponent';
import { updateProfile } from './graphql';
import { compose } from 'ramda';

export default compose(updateProfile)(InfoComponent);
